import api from './api';

const service = {
  async search(params) {
    return await api.get(`/imbalance-forecast`, { params });
  },
}

export default service;